import { Link } from "react-router";
import styled, { css } from "styled-components";

import { Palette } from "../../core/styles/theme";

const linkStyles = css`
    &.aevi-link {
        font-family: RobotoLight, sans-serif;
        color: ${Palette.HeroGreen};
        font-size: 12pt;
        font-weight: bold;
        text-decoration: none;
    }
`;

const AnchorHtmlStyle = styled.a`
    ${linkStyles};
`;
const LinkAntStyle = styled(Link)`
    ${linkStyles};
`;

export const LinkHtmlStyle = styled(AnchorHtmlStyle).attrs(() => ({ className: "aevi-link" as string }))``;
export const LinkStyle = styled(LinkAntStyle).attrs(() => ({ className: "aevi-link" as string }))``;
